import client from "../client";
import { apiList } from "../apiList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // returns list bettingOldHistoryof all the people
  bettingOldHistory: (payload) => client.post(apiList.bettingOldHistory, {json: payload}),
};

// {userId: userId, startDate: startDate, endDate: endDate}